import PropTypes from 'prop-types'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import styles from './ItemUsuario.module.css'

const STATUS_BUTTON_CLASS = {
  enabled: 'statusButtonEnabled',
  inactivo: 'statusButtonInactivo',
  disabled: 'statusButtonDisabled'
}

const getStatusButtonClass = (usuario) => {
  if (usuario.habilitadoEnEBM) return STATUS_BUTTON_CLASS.enabled
  if (usuario.fueHabilitado) return STATUS_BUTTON_CLASS.inactivo
  return STATUS_BUTTON_CLASS.disabled
}

const ItemUsuario = ({
  usuario,
  seleccionado,
  onToggleSeleccion,
  onEditar,
  onAlta,
  puedeEditar,
  onChangeEstado
}) => {
  const puedeCambiarEstado = usuario.habilitadoEnEBM || usuario.fueHabilitado
  return (
    <tr className={styles.row}>
      <td className={styles.checkboxCell}>
        <Checkbox
          name={`usuario-${usuario.idRegistro}`}
          checked={seleccionado}
          onChange={() => onToggleSeleccion(usuario.idRegistro)}
          aria-label={`Seleccionar colaborador ${usuario.usuario}`}
        />
      </td>
      <td>{usuario.usuario}</td>
      <td>{usuario.nombre}</td>
      <td>{usuario.apellido}</td>
      <td>{usuario.email}</td>
      <td>{usuario.telefono}</td>
      <td>{usuario.dni}</td>
      <td>{usuario.rol || '-'}</td>
      <td>
        <button
          type="button"
          className={`${styles.statusButton} ${styles[getStatusButtonClass(usuario)]}`}
          onClick={() => onChangeEstado(usuario.idRegistro)}
          title={
            !puedeCambiarEstado
              ? 'El estado se define al completar el alta'
              : usuario.habilitadoEnEBM
                ? 'Click para deshabilitar'
                : 'Click para habilitar'
          }
          disabled={!puedeCambiarEstado}
        >
          <span className={styles.statusDot} />
          {usuario.habilitadoEnEBM
            ? 'Habilitado'
            : usuario.fueHabilitado
              ? 'Inactivo'
              : 'Deshabilitado'}
        </button>
      </td>
      <td>
        {puedeEditar || usuario.fueHabilitado ? (
          <button type="button" className={styles.editButton} onClick={() => onEditar(usuario)}>
            Editar
          </button>
        ) : (
          <button type="button" className={styles.editButtonActive} onClick={() => onAlta(usuario)}>
            Completar alta
          </button>
        )}
      </td>
    </tr>
  )
}

ItemUsuario.propTypes = {
  usuario: PropTypes.shape({
    idRegistro: PropTypes.string.isRequired,
    idUsuario: PropTypes.string.isRequired,
    usuario: PropTypes.string.isRequired,
    nombre: PropTypes.string.isRequired,
    apellido: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    telefono: PropTypes.string.isRequired,
    dni: PropTypes.string.isRequired,
    rol: PropTypes.string,
    habilitadoEnEBM: PropTypes.bool.isRequired,
    fueHabilitado: PropTypes.bool,
    idUsuarioEstado: PropTypes.number
  }).isRequired,
  seleccionado: PropTypes.bool.isRequired,
  onToggleSeleccion: PropTypes.func.isRequired,
  onEditar: PropTypes.func.isRequired,
  onAlta: PropTypes.func.isRequired,
  puedeEditar: PropTypes.bool.isRequired,
  onChangeEstado: PropTypes.func.isRequired
}

export default ItemUsuario
